import { render, staticRenderFns } from "./Relations.vue?vue&type=template&id=b4cf8f7c&scoped=true"
import script from "./Relations.vue?vue&type=script&lang=js"
export * from "./Relations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cf8f7c",
  null
  
)

export default component.exports